const AUTH_TOKEN_KEY = 'authToken';
const AUTH_USER_KEY = 'authUser';
const AUTH_SESSION_KEY = 'authSession';
const AUTH_FLAG_KEY = 'isLoggedIn';

function hasWindow() {
  return typeof window !== 'undefined';
}

export function getAuthToken() {
  if (!hasWindow()) return '';
  const fromTokenKey = window.localStorage.getItem(AUTH_TOKEN_KEY);
  if (fromTokenKey) return fromTokenKey;

  const rawSession = window.localStorage.getItem(AUTH_SESSION_KEY);
  if (!rawSession) return '';
  try {
    const session = JSON.parse(rawSession);
    return session?.token || '';
  } catch {
    return '';
  }
}

export function getAuthUser() {
  if (!hasWindow()) return null;
  const rawSession = window.localStorage.getItem(AUTH_SESSION_KEY);
  if (rawSession) {
    try {
      const session = JSON.parse(rawSession);
      if (session?.user) return session.user;
    } catch {
      // continue with fallback keys
    }
  }

  const rawUser = window.localStorage.getItem(AUTH_USER_KEY);
  if (!rawUser) return null;

  try {
    return JSON.parse(rawUser);
  } catch {
    return null;
  }
}

export function saveAuthSession({ token, user }) {
  if (!hasWindow()) return;
  const existingToken = getAuthToken();
  const existingUser = getAuthUser();
  const nextToken = token || existingToken;
  const nextUser = user || existingUser;

  if (nextToken) window.localStorage.setItem(AUTH_TOKEN_KEY, nextToken);
  if (nextUser) window.localStorage.setItem(AUTH_USER_KEY, JSON.stringify(nextUser));

  window.localStorage.setItem(
    AUTH_SESSION_KEY,
    JSON.stringify({
      token: nextToken,
      user: nextUser,
      isLoggedIn: Boolean(nextToken),
      savedAt: new Date().toISOString(),
    }),
  );
  window.localStorage.setItem(AUTH_FLAG_KEY, nextToken ? 'true' : 'false');
}

export function clearAuthSession() {
  if (!hasWindow()) return;
  window.localStorage.removeItem(AUTH_TOKEN_KEY);
  window.localStorage.removeItem(AUTH_USER_KEY);
  window.localStorage.removeItem(AUTH_SESSION_KEY);
  window.localStorage.removeItem(AUTH_FLAG_KEY);
}

export function isUserLoggedIn() {
  return Boolean(getAuthToken());
}

export function isAdminUser() {
  const user = getAuthUser();
  return String(user?.role || '').toUpperCase() === 'ADMIN';
}
